<template>
  <div class="lj-edit-form">
    <el-form :disabled="disabled" ref="form" label-width="150px" :model="{formItems:formItems}">
      <el-row>
        <el-col
          :span="data.block || data.type === 'line' ? 24 : 12"
          v-for="(data,index2) in formItems"
          :key="index2"
        >
          <el-form-item
            :label="data.label"
            v-if="data.type&&!data.notEdit&& data.if?data.if(formData):true"
            v-show="data.type !== 'line'"
            :rules="data.rules"
            :prop="`formItems[${index2}].value`"
          >
            <lj-input v-if="data.type" :data="data" v-model="data.value"></lj-input>
<!--                                        自定义插槽-->
            <slot
              :name="data.name"
              v-if="data.type === 'slot'"
              v-bind="data"
              :value="data.value"
            >{{data.value}}</slot>
            <!--  文本-->
            <span v-if="data.type==='txt'">{{ data.value }}</span>
<!--                                        图片-->
            <template v-if="data.type === 'images'">
              <el-image

                      v-for="image in data.value"
                      :key="image"
                      style="width: 100px; height: 100px;margin-right: 5px;"
                      :src="image"
                      :z-index="2010"
                      :preview-src-list="data.value"
                      fit="fill"
              ></el-image>
            </template>
            <!--                            帮助-->
            <div v-if="data.helpText" class="help-icon-block">
              <el-tooltip class="el-icon-question" effect="dark" :content="data.helpText">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <!-- 分割线 -->
          <el-divider
            v-if="data.type === 'line'"
            :content-position="data.contentPosition?data.contentPosition:'left'"
          >
            <div :style="data.textStyle?data.textStyle:''">{{ data.text ? data.text : '' }}</div>
          </el-divider>
        </el-col>
      </el-row>
      <el-row v-if="buttons.length>0" type="flex" justify="center">
        <el-col :span="12" style="text-align: center">
          <span class="foot-buttons">
            <el-button
              v-for="(item,index) in buttons"
              :type="item.type"
              :key="index"
            >{{ item.text }}</el-button>
          </span>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import LjInput from "@/components/ljInput/src/index";

export default {
  name: "LjEditForm",
  components: { LjInput },
  props: {
    formItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    block: {},
    disabled: Boolean,
    buttons: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 利用计算属性得出formData
    formData() {
      let obj = {};
      this.formItems.map(item => {
        item.type !== "line" ? (obj[item.name] = item.value) : "";

        //适配后台
        if (item.type === "datePicker") {
          if (item.valueFormat === "yyyy-MM-dd" && !item.formatF) {
            item.valueFormat = "yyyy-MM-dd HH:mm:ss";
          }
        }
        // if(item.type=='slot'){
        //   console.log(item)
        // }
        //适配接口需要传输中文
        if (item.type === "select") {
          let cnName = `${item.name}name`;
          if (item.cnName) cnName = item.cnName;
          if (item.options && item.options.length > 0) {
            let data = item.options.find(s => s.value === item.value);
            if (data) {
              obj[cnName] = data.label;
            }
          }
        }
        //适配接口需要传输中文
        if (item.type === "radio") {
          let cnName = `${item.name}name`;
          if (item.cnName) cnName = item.cnName;
          if (item.options && item.options.length > 0) {
            let data = item.options.find(s => s.value === item.value);
            if (data) {
              obj[cnName] = data.label;
            }
          }
        }
      });
      return obj;
    }
  },
  methods: {
    // 设置formData的值
    setData(name, value) {
      try {
        let obj = this.formItems.find(i => name === i.name);
        obj.value = value;
        // 上传图片value处理
        return this.formData;
      } catch (e) {
        console.error(e);
      }
    },
    clearAll() {
      for (let i = 0; i < this.formItems.length; i++) {
        this.formItems[i].value =
          this.formItems[i].default ||
          (this.formItems[i].default === 0
            ? 0
            : this.formItems[i].default === false
            ? false
            : "");
      }
    },

    ruleForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve(valid);
          } else {
            reject(valid);
          }
        });
      });
    },
    // 用对象设置form
    setAllDate(object) {
      for (let key in object) {
        try {
          let obj = this.formItems.find(i => key === i.name);
          obj.value = object[key] || object[key] === 0 || object[key] === false ?object[key]:"";
          // 上传图片value处理
          if (
            obj.type === "upload" &&
            obj.limit != 1 &&
            typeof obj.value === "string"
          ) {
            obj.value = obj.value ? obj.value.split(",") : [];
          } else if (
            obj.type === "select" &&
            typeof object[key] === "object" &&
            !Array.isArray(object[key])
          ) {
            obj.value = object[key].code || "";
          }
        } catch (e) {
          console.warn(`设置字段${key}时，发生错误，请检查对象与数组是否匹配`);
        }
      }
      this.$nextTick(()=>{
        this.$forceUpdate();
      });
      return this.formData;
    },
    clearValidate(){
      this.$refs.form.clearValidate()
    }
  },

}
</script>
